import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Trends',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: {
                    '++': [
                      {
                        '@$': 'financialVolume',
                      },
                      ' Performance',
                    ],
                  },
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: {
                            '@$': 'financialVolume',
                          },
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: '2021',
                                  y: {
                                    if: [
                                      [
                                        {
                                          and: [
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgRecordId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgEntityId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          '+': {
                                            '@': '2021_orgGlExpenses',
                                          },
                                        },
                                      ],
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@$': 'piRecordId',
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '@': '2021_piGlExpenses',
                                          },
                                        },
                                      ],
                                      {
                                        '+': {
                                          '@': '2021_projectsGlExpenses',
                                        },
                                      },
                                    ],
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: '2022',
                                  y: {
                                    if: [
                                      [
                                        {
                                          and: [
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgRecordId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgEntityId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          '+': {
                                            '@': '2022_orgGlExpenses',
                                          },
                                        },
                                      ],
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@$': 'piRecordId',
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '@': '2022_piGlExpenses',
                                          },
                                        },
                                      ],
                                      {
                                        '+': {
                                          '@': '2022_projectsGlExpenses',
                                        },
                                      },
                                    ],
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: '2023',
                                  y: {
                                    if: [
                                      [
                                        {
                                          and: [
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgRecordId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                            {
                                              not: {
                                                '=': [
                                                  {
                                                    '@$': 'orgEntityId',
                                                  },
                                                  null,
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          '+': {
                                            '@': '2023_orgGlExpenses',
                                          },
                                        },
                                      ],
                                      [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '@$': 'piRecordId',
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '@': '2023_piGlExpenses',
                                          },
                                        },
                                      ],
                                      {
                                        '+': {
                                          '@': '2023_projectsGlExpenses',
                                        },
                                      },
                                    ],
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'trends',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    financialVolume: 'MTDC',
  },
  subqueries: {
    '2021_piGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2021',
          },
          start: {
            $date: '1/1/2021',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2022_piGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2023_piGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2024_piGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2021_orgGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2021',
          },
          start: {
            $date: '1/1/2021',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
      },
    },
    '2022_orgGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
      },
    },
    '2023_orgGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
      },
    },
    '2024_orgGlExpenses': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '+': {
          '@': 'projectsExpenses',
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            not: {
              '=': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                null,
              ],
            },
          },
          target: 'ent:!projects:!proj',
          selection: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenseAmounts',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    {
                      if: [
                        [
                          {
                            '=': [
                              {
                                '@$': 'financialVolume',
                              },
                              'MTDC',
                            ],
                          },
                          'mtdcAmount',
                        ],
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              ],
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'TDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!code',
                  },
                },
              },
            },
          },
        },
      },
    },
    '2021_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2021',
          },
          start: {
            $date: '1/1/2021',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '+': {
          '->': [
            {
              '@': 'glExpenses',
            },
            {
              '@>': [
                {
                  '@$': '$value',
                },
                {
                  if: [
                    [
                      {
                        '=': [
                          {
                            '@$': 'financialVolume',
                          },
                          'MTDC',
                        ],
                      },
                      'mtdcAmount',
                    ],
                    'tdcAmount',
                  ],
                },
              ],
            },
          ],
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'TDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
      },
    },
    '2022_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '+': {
          '->': [
            {
              '@': 'glExpenses',
            },
            {
              '@>': [
                {
                  '@$': '$value',
                },
                {
                  if: [
                    [
                      {
                        '=': [
                          {
                            '@$': 'financialVolume',
                          },
                          'MTDC',
                        ],
                      },
                      'mtdcAmount',
                    ],
                    'tdcAmount',
                  ],
                },
              ],
            },
          ],
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'TDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
      },
    },
    '2023_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '+': {
          '->': [
            {
              '@': 'glExpenses',
            },
            {
              '@>': [
                {
                  '@$': '$value',
                },
                {
                  if: [
                    [
                      {
                        '=': [
                          {
                            '@$': 'financialVolume',
                          },
                          'MTDC',
                        ],
                      },
                      'mtdcAmount',
                    ],
                    'tdcAmount',
                  ],
                },
              ],
            },
          ],
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'TDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
      },
    },
    '2024_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '+': {
          '->': [
            {
              '@': 'glExpenses',
            },
            {
              '@>': [
                {
                  '@$': '$value',
                },
                {
                  if: [
                    [
                      {
                        '=': [
                          {
                            '@$': 'financialVolume',
                          },
                          'MTDC',
                        ],
                      },
                      'mtdcAmount',
                    ],
                    'tdcAmount',
                  ],
                },
              ],
            },
          ],
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'TDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
      },
    },
  },
}
